import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon, { iconPropTypes, ICON_OPTIONS } from '../Icon';

const ICON_BUTTON_OPTIONS = {
  ...ICON_OPTIONS,
};

const ICON_BUTTON_CONSTS = {
  TYPE: 'button',
};

const StyledButton = styled.button`
  all: unset;
  & :enabled {
    cursor: pointer;
  }
`;

const IconButton = props => {
  const { className, handleClick, ...otherProps } = props;
  return (
    <StyledButton
      className={className}
      type={ICON_BUTTON_CONSTS.TYPE}
      onClick={handleClick}
    >
      <Icon {...otherProps} />
    </StyledButton>
  );
};

const iconButtonPropTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
  ...iconPropTypes,
};
const iconButtonDefaultProps = {
  className: undefined,
  handleClick: undefined,
};

IconButton.propTypes = iconButtonPropTypes;
IconButton.defaultProps = iconButtonDefaultProps;
export default IconButton;
export { ICON_BUTTON_OPTIONS, iconButtonDefaultProps, iconButtonPropTypes };
